import { render } from "./itemImage.vue?vue&type=template&id=42e9ce9b&scoped=true"
import script from "./itemImage.vue?vue&type=script&lang=js"
export * from "./itemImage.vue?vue&type=script&lang=js"

import "./itemImage.vue?vue&type=style&index=0&id=42e9ce9b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42e9ce9b"]])

export default __exports__